import React from 'react'; 
import '../../css/Shared/Footer.css';

function Footer() {
  return (
   <footer class="page-footer font-small" id='footer'>
     <div class="footer-copyright text-center pb-4" > 
      <p id="footerContent" style={{marginTop:"8%", marginBottom:0}}>© Copyright Transnet 2021. All Rights Reserved.</p>
     </div>
     {/* <small  id="FooterReleaseText">Test-2</small> */}
   </footer>
  );
}
export default Footer;
